import React from 'react';

const Maintenance: React.FC = () => {
    return (
        <div>
            <h1>Maintenance Page</h1>
            <p>This is the maintenance page for assets.</p>
        </div>
    );
};

export default Maintenance;